<div class="w-100">
  <div class="p-4">
    <!-- Lightbox Overlay -->
    <div class="top-0 start-0 w-100 bg-opacity-50 d-flex justify-content-center align-items-center">
      <div class="bg-white">
        <!-- Close Button -->
        <div class="text-end mb-2">
          <i class="fa fa-times-circle-o text-danger fs-3" role="button" aria-hidden="true" (click)="onClose()"></i>
        </div>
        <!-- Main Content Section -->
        <div class="row">
          <!-- Details Section -->
          <div class="col-md-6">
            <!-- Title and Business Name -->
            <div class="d-flex align-items-center mb-3 p-1">
              <div class="flex-grow-1 d-flex justify-content-between align-items-center">
                <div class="d-flex flex-column">
                  <h1>
                    <!-- Display Artist or Gallery Product Name -->
                    @if (isArtist) {
                      <div class="mb-2 text-dark">{{ ArtistProduct.Name }}</div>
                    }
                    @if (isGallery) {
                      <div class="mb-2 text-dark">{{ GalleryProduct.Name }}</div>
                    }
                  </h1>
                  <h2 class="fw-bold">{{ 'artistSelectedProductDialog.by' | transloco: { businessName: BusinessName } }}</h2>
                </div>
              </div>
            </div>

            <!-- Descriptions -->
            @if (isArtist) {
              <!-- Short Description -->
              @if (ArtistProduct.ShortDescription) {
                <div class="fw-bold mt-2 text-white p-2 rounded section-header">{{ 'artistSelectedProductDialog.shortDescription' | transloco }}</div>
                <div class="detail-item mb-2 text-gray-600 p-1 mt-2">
                  {{ ArtistProduct.ShortDescription }}
                </div>
              }
              <!-- Long Description -->
              @if (ArtistProduct.LongDescription) {
                <div class="fw-bold mt-2 text-white p-2 rounded section-header">{{ 'artistSelectedProductDialog.longDescription' | transloco }}</div>
                <div class="detail-item mb-2 text-gray-600 p-1 mt-2">
                  {{ ArtistProduct.LongDescription }}
                </div>
              }
            }

            @if (isGallery) {
              <!-- Gallery Short Description -->
              @if (GalleryProduct.ArtistShortDescription) {
                <div class="fw-bold mt-2 text-white p-2 rounded section-header">{{ 'artistSelectedProductDialog.shortDescription' | transloco }}</div>
                <div class="detail-item mb-2 text-gray-600 p-1 mt-2">
                  {{ GalleryProduct.ArtistShortDescription }}
                </div>
              }
              <!-- Gallery Long Description -->
              @if (GalleryProduct.ArtistLongDescription) {
                <div class="fw-bold mt-2 text-white p-2 rounded section-header">{{ 'artistSelectedProductDialog.longDescription' | transloco }}</div>
                <div class="detail-item mb-2 text-gray-600 p-1 mt-2">
                  {{ GalleryProduct.ArtistLongDescription }}
                </div>
              }
            }

            <!-- Series Name -->
            @if (isArtist && ArtistProduct.SeriesName) {
              <div class="d-flex align-items-center">
                <div class="text-uppercase fw-semibold">{{ 'artistSelectedProductDialog.series' | transloco }}</div>
                <div class="ps-1">{{ ArtistProduct.SeriesName }}</div>
              </div>
            }

            <!-- Material -->
            @if (isArtist && ArtistProduct.Material) {
              <div class="d-flex align-items-center">
                <div class="text-uppercase fw-semibold">{{ 'artistSelectedProductDialog.material' | transloco }}</div>
                <div class="ps-1">{{ ArtistProduct.Material }}</div>
              </div>
            }

            <!-- Features -->
            @if (isArtist && ArtistProduct?.SelectedGlazes?.length) {
              <div class="text-uppercase mb-2 fw-semibold pt-1">{{ 'artistSelectedProductDialog.features' | transloco }}</div>
              <ul class="list-unstyled d-flex flex-row flex-wrap">
                @for (glaze of ArtistProduct.SelectedGlazes; track glaze) {
                  <li class="fw-bold text-white p-1 rounded section-header me-1 mt-1">
                    {{ glaze }}
                  </li>
                }
              </ul>
            }

            <!-- Availability Section -->
            <!-- <ng-container *ngIf="isArtist && ArtistProduct.GalleryId">
            <div class="mt-3">
              <h4 class="product-headings">Available from</h4>
              <div>{{ ArtistProduct.GalleryName }}</div>
              <div>
                <a [href]="shareLink" target="_blank">{{ shareLink }}</a>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="isGallery && GalleryProduct.ArtistId">
            <div class="mt-2">
              <h4 class="product-headings">Available from</h4>
              <div>
                <a [href]="shareLink" target="_blank">{{ shareLink }}</a>
              </div>
            </div>
          </ng-container> -->
        </div>

        <!-- Image Section -->
        @if (isArtist) {
          <div class="col-md-6 text-center">
            <img [src]="ArtistProduct.ProductImgUrl" alt="{{ ArtistProduct.Name }}" class="img-fluid rounded shadow">
          </div>
        }
        @if (isGallery) {
          <div class="col-md-6 text-center">
            <img [src]="GalleryProduct.ProductImgUrl" alt="{{ GalleryProduct.Name }}" class="img-fluid rounded shadow">
          </div>
        }
      </div>
    </div>
  </div>
</div>
</div>
